import * as React from 'react';
import { withRouter } from 'react-router';
import { compose, withProps } from 'recompose';
import isEqual from 'lodash/isEqual';
import { withTranslation } from 'react-i18next';
import NavigationPromptModal from '../components/NavigationPromptModal';
function withNavigationPrompt(createProps) {
    const initialState = {
        currentLocation: null,
        targetLocation: null,
        open: false,
    };
    let unblock = () => null;
    return (Comp) => {
        class WrappedComponent extends React.Component {
            constructor(props) {
                super(props);
                this.state = initialState;
                this.unblock = () => null;
                this.onCancel = this.onCancel.bind(this);
                this.onConfirm = this.onConfirm.bind(this);
                this.onBeforeUnload = this.onBeforeUnload.bind(this);
                this.blockHandler = this.blockHandler.bind(this);
            }
            componentDidMount() {
                this.block();
                window.addEventListener('beforeunload', this.onBeforeUnload);
            }
            UNSAFE_componentWillReceiveProps(nextProps) {
                const { isPromptActivated: nextIsPromptActivated, history: nextHistory, whiteListedPaths: nextWhiteListedPaths, } = nextProps;
                const { isPromptActivated, history, whiteListedPaths } = this.props;
                if (isPromptActivated !== nextIsPromptActivated ||
                    !isEqual(nextHistory.location, history.location) ||
                    !isEqual(whiteListedPaths, nextWhiteListedPaths)) {
                    unblock();
                    this.block();
                }
            }
            componentWillUnmount() {
                unblock();
                window.removeEventListener('beforeunload', this.onBeforeUnload);
            }
            blockHandler(targetLocation) {
                const { history, isPromptActivated, whiteListedPaths = [], searchQueryCheck = false } = this.props;
                const hasPathnameChanged = history.location.pathname !== targetLocation.pathname;
                const hasSearchQueryChanged = history.location.search !== targetLocation.search;
                const hasUrlChanged = searchQueryCheck ? hasPathnameChanged || hasSearchQueryChanged : hasPathnameChanged;
                const isTargetWhiteListed = whiteListedPaths.includes(targetLocation.pathname);
                const hasChanged = isPromptActivated && hasUrlChanged && !isTargetWhiteListed;
                if (hasChanged) {
                    this.setState({
                        currentLocation: history.location,
                        targetLocation,
                        open: true,
                    });
                    return false;
                }
            }
            block() {
                unblock = this.props.history.block(this.blockHandler);
            }
            onBeforeUnload(e) {
                const { isPromptActivated } = this.props;
                if (isPromptActivated) {
                    e.returnValue = false;
                }
            }
            onConfirm() {
                const { history } = this.props;
                const { currentLocation, targetLocation } = this.state;
                unblock();
                if (currentLocation) {
                    history.replace(currentLocation);
                }
                if (targetLocation) {
                    history.push(targetLocation);
                }
                this.setState(initialState);
            }
            onCancel() {
                const { currentLocation } = this.state;
                this.setState(initialState);
                unblock();
                if (currentLocation) {
                    this.props.history.replace(currentLocation);
                }
                this.block();
            }
            render() {
                const { t, title, description } = this.props;
                const { confirmBtnText = t('common:confirm') } = this.props;
                return (React.createElement(React.Fragment, null,
                    React.createElement(NavigationPromptModal, { open: this.state.open, title: title, description: description, confirmBtnText: String(confirmBtnText), onConfirm: this.onConfirm, onCancel: this.onCancel }),
                    React.createElement(Comp, { ...this.props })));
            }
        }
        return compose(withRouter, withProps(createProps), withTranslation())(WrappedComponent);
    };
}
export default withNavigationPrompt;
//# sourceMappingURL=withNavigationPrompt.js.map